import { render, staticRenderFns } from "./ResidenceofPartner.vue?vue&type=template&id=0fcf5400&scoped=true&"
import script from "./ResidenceofPartner.vue?vue&type=script&lang=js&"
export * from "./ResidenceofPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf5400",
  null
  
)

export default component.exports